module.exports = __webpack_public_path__ + "static/img/OM12.c73a3e2e.png";